export default "__VITE_ASSET__CZnMpq6n__"